import { render, staticRenderFns } from "./AdminConfigLayer.vue?vue&type=template&id=0b386dc0"
import script from "./AdminConfigLayer.vue?vue&type=script&lang=ts"
export * from "./AdminConfigLayer.vue?vue&type=script&lang=ts"
import style0 from "./AdminConfigLayer.vue?vue&type=style&index=0&id=0b386dc0&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports